import Vue from "vue";

const state = {
  drawer: false
};

const getters = {
  drawer: state => state.drawer
};

const mutations = {
  SET_DRAWER(state, data) {
    Vue.set(state, "drawer", data);
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations
};
